import { useNavigate, useLocation } from 'react-router-dom';
import { useLang } from '../LangContext';
import { useT } from '../i18n';

const NAV_ITEMS = [
  {
    key: 'home',
    path: '/',
    label: 'navHome',
    icon: (active) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill={active ? 'currentColor' : 'none'}
        stroke={active ? 'none' : 'currentColor'} strokeWidth={active ? 0 : 1.5}>
        <path fill={active ? 'currentColor' : 'none'}
          d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
          stroke={active ? 'none' : 'currentColor'} strokeWidth={active ? 0 : 1.5}
          strokeLinejoin="round"
        />
        {!active && <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>}
      </svg>
    ),
  },
  {
    key: 'menu',
    path: '/menu',
    label: 'navMenu',
    icon: (active) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill={active ? 'currentColor' : 'none'}
        stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 6h18M3 12h18M3 18h18" strokeWidth="2"/>
      </svg>
    ),
  },
  {
    key: 'rewards',
    path: '/barcode-member',
    label: 'navRewards',
    icon: (active) => (
      <svg width="24" height="24" viewBox="0 0 24 24"
        fill={active ? 'currentColor' : 'none'}
        stroke="currentColor" strokeWidth="1.5">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
          strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    key: 'profile',
    path: '/profile',
    label: 'navProfile',
    icon: (active) => (
      <svg width="24" height="24" viewBox="0 0 24 24"
        fill={active ? 'currentColor' : 'none'}
        stroke="currentColor" strokeWidth="1.5">
        <circle cx="12" cy="8" r="4" strokeLinejoin="round"/>
        <path d="M4 20c0-4 3.58-7 8-7s8 3 8 7" strokeLinecap="round"/>
      </svg>
    ),
  },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { lang } = useLang();
  const t = useT(lang);

  return (
    <nav
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        maxWidth: 390,
        margin: '0 auto',
        height: 76,
        backgroundColor: '#F8F5FF',
        borderRadius: '24px 24px 0 0',
        boxShadow: '0px -4px 16px rgba(45, 45, 66, 0.06)',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: '0 8px 8px',
        zIndex: 50,
      }}
    >
      {NAV_ITEMS.map(({ key, path, label, icon }) => {
        const active = location.pathname === path ||
          (path === '/' && location.pathname === '/');
        return (
          <button
            key={key}
            onClick={() => navigate(path)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
              padding: '8px 12px',
              borderRadius: 16,
              border: 'none',
              cursor: 'pointer',
              background: active ? 'rgba(255, 92, 54, 0.1)' : 'transparent',
              color: active ? '#FF5C36' : '#9898a8',
              transition: 'all 0.2s',
              transform: active ? 'scale(1.1)' : 'scale(1)',
              minWidth: 44,
              minHeight: 44,
            }}
            aria-label={t(label)}
          >
            {icon(active)}
            <span style={{
              fontSize: 9,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: active ? 700 : 500,
              letterSpacing: '0.04em',
              textTransform: 'uppercase',
            }}>
              {t(label)}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
